import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagamentoFolhaRoutingModule } from './pagamento-folha-routing.module';
import { PagamentoFolhaListarComponent } from './pagamento-folha-listar/pagamento-folha-listar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmationService } from 'primeng/api';
import { RippleModule } from "primeng/ripple";
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { SplitButtonModule } from "primeng/splitbutton";
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    PagamentoFolhaListarComponent
  ],
  imports: [
    CommonModule,
    PagamentoFolhaRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    ProgressSpinnerModule,
    DropdownModule,
    MessagesModule,
    ConfirmDialogModule,
    CalendarModule,
    RippleModule,
    DialogModule,
    InputNumberModule,
    SplitButtonModule,
    TooltipModule
],
  providers: [ConfirmationService]
})
export class PagamentoFolhaModule { }
